import { useOffer } from "$store/sdk/useOffer.ts";
import { formatPrice } from "$store/sdk/format.ts";
import { AddToCartMultiSku } from "$store/islands/product/content/AddToCartMultiSku.tsx";
import {
  selectedProducts,
} from "$store/components/product/content/BuyTogether/selectedProducts.ts";
import { toProductItem } from "site/sdk/ga4/transform/toProductItem.ts";

export default function Total() {
  const { items, total } = selectedProducts.value.reduce(
    (acc, product) => {
      const { price = 0, seller = "1" } = useOffer(product.offers);

      return {
        items: [...acc.items, { id: product.sku, quantity: 1, seller }],
        total: acc.total + price,
      };
    },
    { items: [], total: 0 } as {
      items: Array<{ id: string; quantity: number; seller: string }>;
      total: number;
    },
  );

  const analytics = {
    items: selectedProducts.value.map((product, index) =>
      toProductItem(product, { quantity: 1, index })
    ),
    view: {
      id: "buy_together",
      name: "Compre junto",
    },
  };

  return (
    <div class="w-full h-full py-16 px-6 rounded-2xl bg-tw-primary-100 text-white text-center grid justify-items-center content-between gap-10">
      <div>
        <span class="text-3xl font-maven font-extrabold block">
          Compre agora
        </span>

        <span class="text-tw-neutral-150 font-semibold text-pretty block">
          Uma seleção completa para você!
        </span>
      </div>

      <div>
        <span class="text-tw-neutral-150 leading-5 font-nunito font-bold block">
          Por apenas:
        </span>

        <span class="text-3xl leading-9 font-maven font-extrabold block">
          {formatPrice(total)}
        </span>
      </div>

      <AddToCartMultiSku
        items={items}
        customClass="!w-40"
        analytics={analytics}
      />
    </div>
  );
}
